import { render } from "./speakers.vue?vue&type=template&id=5d7b6e90&scoped=true"
import script from "./speakers.vue?vue&type=script&lang=js"
export * from "./speakers.vue?vue&type=script&lang=js"

import "./speakers.vue?vue&type=style&index=0&id=5d7b6e90&lang=scss&scoped=true"
import "./speakers.vue?vue&type=style&index=1&id=5d7b6e90&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5d7b6e90"

export default script